module.exports = __webpack_public_path__ + "img/video.54ab2b1b.png";